import React from 'react';
import { Formik } from 'formik';

import Button from '@RHEnvironmental/pattern-library/dist/js/components/Button';
import InputFieldSet from '@RHEnvironmental/pattern-library/dist/js/components/InputFieldSet';
import InputField from '@RHEnvironmental/pattern-library/dist/js/components/InputField';
import InlineButtonPanel from '@RHEnvironmental/pattern-library/dist/js/components/InlineButtonPanel';

import { responseErrorFormatter } from '../../../services/http/errors';
import serviceProviderApi from '../../../services/api/serviceProviderApi';

const AddEditServiceProvider = ({ onSuccess, onCancel, serviceProvider }) => {
    const initialFormValues = {
        name: serviceProvider?.name ?? '',
        contact_name: serviceProvider?.contact_name ?? '',
        contact_email: serviceProvider?.contact_email ?? '',
        contact_phone: serviceProvider?.contact_phone ?? '',
    };

    const initialFormStatus = {
        errors: {},
    };

    const onSubmit = async (values, { setSubmitting, setStatus }) => {
        try {
            const createUpdate = () =>
                serviceProvider
                    ? serviceProviderApi.update(serviceProvider.id, {
                          ...values,
                          id: serviceProvider.id,
                      })
                    : serviceProviderApi.create(values);
            const {
                data: { data },
            } = await createUpdate();
            onSuccess(data);
        } catch ({ response }) {
            setStatus({
                errors: responseErrorFormatter(response.data.errors),
            });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Formik
            onSubmit={onSubmit}
            initialValues={initialFormValues}
            initialStatus={initialFormStatus}
        >
            {({ values, status, handleChange, handleSubmit, isSubmitting }) => (
                <form onSubmit={handleSubmit}>
                    <InputFieldSet>
                        <InputField
                            id="name"
                            onChange={handleChange}
                            value={values.name}
                            required
                            errors={status.errors.name}
                            name="name"
                            type="name"
                        >
                            Name
                        </InputField>
                        <InputField
                            id="contact_name"
                            onChange={handleChange}
                            value={values.contact_name}
                            required
                            errors={status.errors.contact_name}
                            name="contact_name"
                            type="text"
                        >
                            Contact name
                        </InputField>
                        <InputField
                            id="contact_email"
                            onChange={handleChange}
                            value={values.contact_email}
                            required
                            errors={status.errors.contact_email}
                            name="contact_email"
                            type="text"
                        >
                            Contact email
                        </InputField>
                        <InputField
                            id="contact_phone"
                            onChange={handleChange}
                            value={values.contact_phone}
                            required
                            errors={status.errors.contact_phone}
                            name="contact_phone"
                            type="text"
                        >
                            Contact phone
                        </InputField>
                    </InputFieldSet>
                    <InlineButtonPanel>
                        <Button type="submit" disabled={isSubmitting}>
                            {serviceProvider ? `Save` : `Add`}
                        </Button>
                        <Button isInverted onClick={onCancel}>
                            Cancel
                        </Button>
                    </InlineButtonPanel>
                </form>
            )}
        </Formik>
    );
};

export default AddEditServiceProvider;
